import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b56c50c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor-header" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "文件", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导入 pptist 文件")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出 pptist 文件")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("导出 PPTX")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("导出图片")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("导出 JSON")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("打印 / 导出 PDF")
const _hoisted_12 = { class: "menu-item" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "编辑", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("撤销")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("重做")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("添加页面")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("删除页面")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("重置幻灯片")
const _hoisted_20 = { class: "menu-item" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "演示", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("从头开始")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("从当前页开始")
const _hoisted_25 = { class: "menu-item" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode()
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "帮助", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode("意见反馈")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("快捷键")
const _hoisted_30 = { class: "right" }
const _hoisted_31 = {
  href: "https://github.com/pipipi-pikachu/PPTist",
  target: "_blank"
}
const _hoisted_32 = { class: "menu-item" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'
import useScreening from '@/hooks/useScreening'
import useSlideHandler from '@/hooks/useSlideHandler'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useExport from '@/hooks/useExport'

import HotkeyDoc from './HotkeyDoc.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mainStore = useMainStore()
const { gridLineSize, showRuler } = storeToRefs(mainStore)

const { enterScreening, enterScreeningFromStart } = useScreening()
const { createSlide, deleteSlide, resetSlides } = useSlideHandler()
const { redo, undo } = useHistorySnapshot()
const { importSpecificFile } = useExport()

const setDialogForExport = mainStore.setDialogForExport

const toggleGridLines = () => {
  mainStore.setGridLineSize(gridLineSize.value ? 0 : 50)
}

const toggleRuler = () => {
  mainStore.setRulerState(!showRuler.value)
}

const hotkeyDrawerVisible = ref(false)

const goIssues = () => {
  window.open('https://github.com/pipipi-pikachu/PPTist/issues')
}

return (_ctx: any,_cache: any) => {
  const _component_IconFolderClose = _resolveComponent("IconFolderClose")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_IconPpt = _resolveComponent("IconPpt")!
  const _component_IconHelpcenter = _resolveComponent("IconHelpcenter")!
  const _component_IconShare = _resolveComponent("IconShare")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_IconGithub = _resolveComponent("IconGithub")!
  const _component_Drawer = _resolveComponent("Drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Dropdown, { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_component_Menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_FileInput, {
                accept: ".pptist",
                onChange: _cache[0] || (_cache[0] = files => _unref(importSpecificFile)(files))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MenuItem, null, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setDialogForExport)('pptist')))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setDialogForExport)('pptx')))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(setDialogForExport)('image')))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(setDialogForExport)('json')))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(setDialogForExport)('pdf')))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_IconFolderClose),
            _hoisted_4,
            _hoisted_5
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Dropdown, { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_component_Menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_MenuItem, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(undo)()))
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(redo)()))
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(createSlide)()))
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(deleteSlide)()))
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (toggleGridLines()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(gridLineSize) ? '关闭网格线' : '打开网格线'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (toggleRuler()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(showRuler) ? '关闭标尺' : '打开标尺'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(resetSlides)()))
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_IconEdit),
            _hoisted_13,
            _hoisted_14
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Dropdown, { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_component_Menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_MenuItem, {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(enterScreeningFromStart)()))
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(enterScreening)()))
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_IconPpt),
            _hoisted_21,
            _hoisted_22
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Dropdown, { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_component_Menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_MenuItem, {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (goIssues()))
              }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (hotkeyDrawerVisible.value = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_IconHelpcenter),
            _hoisted_26,
            _hoisted_27
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        title: "导出"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "menu-item",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(setDialogForExport)('pptx')))
          }, [
            _createVNode(_component_IconShare, {
              size: "18",
              fill: "#666"
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        title: "幻灯片放映"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "menu-item",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(enterScreening)()))
          }, [
            _createVNode(_component_IconPpt, {
              size: "19",
              fill: "#666",
              style: {"margin-top":"1px"}
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("a", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_IconGithub, {
            size: "18",
            fill: "#666"
          })
        ])
      ])
    ]),
    _createVNode(_component_Drawer, {
      width: "320",
      placement: "right",
      closable: false,
      visible: hotkeyDrawerVisible.value,
      onClose: _cache[19] || (_cache[19] = ($event: any) => (hotkeyDrawerVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(HotkeyDoc)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})